import { Button, CircularProgress, Tooltip } from '@mui/material';

// The disabled Impersonate button both members tables show while the member's
// impersonation data (the team's tags) is still loading.
export const ImpersonateLoadingButton = () => (
  <Tooltip title="Loading impersonation data...">
    <span>
      <Button
        color="primary"
        variant="outlined"
        disabled
        aria-label="Loading impersonation data"
        aria-busy="true"
      >
        <CircularProgress size={18} aria-hidden="true" />
      </Button>
    </span>
  </Tooltip>
);
